import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { send } from "../../app/appSlice";
import { AppThunkApi, RootState } from "../../app/store";
import { Organization } from "../../models/organization";
import { firstPage, Page } from "../../models/page";
import {
  OrganizationDetail,
  OrganizationPage,
  OrganizationParams,
} from "../../services/organizationMessage";
interface OrganizationState {
  organizationPage: Page<Organization>;
  organizationDetail?: Organization;
}

const initialState: OrganizationState = {
  organizationPage: firstPage(),
};

// 分页
export const getOrganizationListAsync = createAsyncThunk<
  Page<Organization>,
  OrganizationParams,
  AppThunkApi
>("AntisepsisData/page", async (params, api) => {
  return send(OrganizationPage(params), api);
});

// 详情
export const getOrganizationDetailAsync = createAsyncThunk<
  void,
  number,
  AppThunkApi
>("AntisepsisDetail/deteil", async (params, api) => {
  return send(OrganizationDetail(params), api);
});

export const organizationListSlice = createSlice({
  name: "OrganizationListStation",
  initialState,
  reducers: {
    setOrganizationList(state, action) {
      state.organizationPage = action.payload;
    },
    setOrganizationDetail(state, action) {
      state.organizationDetail = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOrganizationListAsync.fulfilled, (state, action) => {
      state.organizationPage = action.payload;
    });
    builder.addCase(
      getOrganizationDetailAsync.fulfilled,
      (state, action: any) => {
        state.organizationDetail = action.payload;
      }
    );
  },
});

export const { setOrganizationList, setOrganizationDetail } =
  organizationListSlice.actions;

export const selectOrganizationData = (state: RootState): Page<Organization> =>
  state.Organization.organizationPage;

export const selectOrganizationDetail = (state: RootState) =>
  state.Organization.organizationDetail;

export default organizationListSlice.reducer;
